module.exports = __webpack_public_path__ + "img/6-2.ae4ad366.png";